// src/polyfills/randomUUID.js
(function ensureRandomUUID() {
  const g = window;

  // Asegura window.crypto aunque el WebView sea viejo
  if (!g.crypto) g.crypto = {};

  if (typeof g.crypto.randomUUID !== "function") {
    const getRandomValues =
      g.crypto.getRandomValues?.bind(g.crypto) ||
      ((arr) => {
        // Fallback NO-cripto; suficiente para evitar el crash en WebView antiguos
        for (let i = 0; i < arr.length; i++) arr[i] = Math.floor(Math.random() * 256);
        return arr;
      });

    g.crypto.randomUUID = function () {
      const a = new Uint8Array(16);
      getRandomValues(a);

      // UUID v4
      a[6] = (a[6] & 0x0f) | 0x40;
      a[8] = (a[8] & 0x3f) | 0x80;

      const hex = Array.from(a, (b) => b.toString(16).padStart(2, "0"));
      return `${hex.slice(0, 4).join("")}-${hex.slice(4, 6).join("")}-${hex
        .slice(6, 8)
        .join("")}-${hex.slice(8, 10).join("")}-${hex.slice(10, 16).join("")}`;
    };
  }
})();
